import { addDoc as create, updateDoc as update, deleteDoc as remove } from "firebase/firestore";

export { collection, getDocs, getDoc, doc, query, where } from "firebase/firestore";

// Opt-in development preview: live reads, never production writes.
export const readOnlyPreview = process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_READ_ONLY_PREVIEW === "true";

function assertWritable() {
  if (readOnlyPreview) {
    throw new Error("This local preview is read-only. Nothing was saved to the league.");
  }
}

export async function addDoc(...args) { assertWritable(); return create(...args); }
export async function updateDoc(...args) { assertWritable(); return update(...args); }
export async function deleteDoc(...args) { assertWritable(); return remove(...args); }
